import { gql } from "@apollo/client";

export const ADD_CLIENT_REF = gql`
  mutation addClientRefAddress($input: ClientRefAddressInput!) {
    addClientRefAddress(input: $input) {
      error
      code
      message
      data {
        _id
        firstname
        lastname
        phone_number
        email
        address {
          location {
            latitude
            longitude
          }
        }
        client_UID
        created_by {
          user_id
        }
        created_at
        isDeleted
        default
      }
    }
  }
`;

export const UPDATE_CLIENT_REF_ADDRESS = gql`
  mutation updateClientRefAddress($input: UpdateClientRefAddressInput!) {
    updateClientRefAddress(input: $input) {
      error
      code
      message
      data {
        _id
        firstname
        lastname
        phone_number
        email
        address {
          address
        }
        default
      }
    }
  }
`;

export const DELETE_CLIENT_REF_ADDRESS = gql`
  mutation deleteClientRefAddress($input: DeleteClientRefInput!) {
    deleteClientRefAddress(input: $input) {
      error
      code
      message
      data
    }
  }
`;

